import styled, { css } from 'styled-components';

export const SearchBoxContainer = styled.div(
  ({ theme, showTags }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    border: ${showTags ? `1px solid ${theme.colorsInObjects.gray[600]}` : ``};
    border-radius: ${theme.radius.s};
    padding: ${showTags ? `${theme.spacing.s} ${theme.spacing.sm}` : ''};

    & span {
      background-color: transparent !important;

      &:before {
        background-color: ${theme.colors.verdigris};
        width: ${theme.spacing.sm};
        height: ${theme.spacing.sm};
      }
    }

    & .radio-with-label-label {
      font-weight: ${theme.fontWeight.regular};
      font-size: ${theme.fontSize.s};
      color: ${theme.colors.dimGray};
      letter-spacing: 0;
      line-height: ${theme.lineHeight.lh5};
    }

    & .control-radio-overflow INPUT {
      display: none;
    }
  `
);

export const LabelInputContainer = styled.div``;

export const InputContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: relative;
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.spacing.s};
`;

export const OptionList = styled.ul`
  list-style: none;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.platinumDark};
  border-bottom: none;
  max-height: 136px;
  overflow-y: auto;
  position: absolute;
  width: -webkit-fill-available;
  z-index: 1;
  border-radius: ${({ theme }) => theme.radius.xs};

  &::-webkit-scrollbar {
    width: ${({ theme }) => theme.spacing.xs};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.eerieBlack};
    border-radius: ${({ theme }) => theme.radius.m};
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.platinumDark};
    border-radius: ${({ theme }) => theme.radius.m};
  }
`;

export const OptionItem = styled.li`
  padding: ${({ theme }) => theme.spacing.sm};
  border-bottom: 1px solid ${({ theme }) => theme.colors.platinumDark};
  &:hover {
    background-color: ${({ theme }) => theme.colors.platinumDark};
  }
`;

export const StyledSearchFieldContainer = styled.div(
  ({ theme, isError }) => css`
    padding: ${theme.spacing.sm} ${theme.spacing.m};
    border-radius: ${theme.radius.s};
    background-color: ${theme.colors.white};
    display: flex;
    align-items: center;
    border: 1px solid ${isError ? theme.colors.redCrayola : theme.colors.platinumDark};

    &:focus-within {
      border: 1px solid ${theme.colors.eerieBlack};
      background-color: ${theme.colorsInObjects.gray[200]};
    }
  `
);

export const SearchFieldInput = styled.input`
  flex: 1;
  height: ${({ theme }) => theme.spacing.xm};
  margin-left: ${({ theme }) => theme.spacing.s};
  margin-right: ${({ theme }) => theme.spacing.s};
  border: none;
  background-color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.sm};
  outline: none;
  padding: 0;

  ::placeholder {
    color: ${({ theme }) => theme.colors.silver};
  }

  ::-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.dimGray};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
  }
`;

export const RadioWithLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RadioContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.m};
  padding-left: ${({ theme }) => theme.spacing.s};
  & .radio-with-label-label-wrapper {
    padding-left: ${({ theme }) => theme.spacing.s};
  }
`;

export const IconContainer = styled.div`
  display: flex;
`;

export const StyledTextLabel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;
